import React from 'react';
import styles from './WorkQueue.module.scss';

// See WorkQueues::PriorityService::PRIORITIES
const priorityClass = (priority) => {
  if (priority >= 3) return styles.priorityHigh;
  if (priority === 2) return styles.priorityMedium;
  return styles.priorityNormal;
};

const priorityReasonText = (data) => {
  if (!data?.priority_reason) return undefined;
  return I18n.t(`work_queue_priority_reason_${data.priority_reason}`, { round: data.priority_reporting_round });
};

function WorkQueuePriorityCell({ value, data, itemQueueType, condensedMode }) {
  if (value === undefined || value === null) return null;
  if (itemQueueType && data.queue_type !== itemQueueType) return null;

  return (<>
    <span className={`${styles.priority} ${condensedMode ? styles.condensed : ''} ${priorityClass(value)}`} data-tooltip={priorityReasonText(data)}>
      {value}
    </span>
  </>);
}

export default WorkQueuePriorityCell;
